module.exports = __webpack_public_path__ + "img/logo_akromegalie_web_198x61px.fa0d2718.png";